import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction, IPeriodo } from './interfaces/apiInterfaces';
import { IInitialState, ILastTwelveMonths } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,

  dateSearch: {
    start: '',
    end: '',
  },
  tibsSent: {
    value: 0,
    quantity: 0,
  },
  tibsReceived: {
    value: 0,
    quantity: 0,
  },
  lastTwelveMonths: [],
};

export const getTibFaresFromApi = createAction(
  '@faresApp/tibFares/GET_TIB_FARES_FROM_API'
);

export const gotTibFaresFromApi = createAction<any>(
  '@faresApp/tibFares/GOT_TIB_FARES_FROM_API'
);

export const gotErrorFromTibFaresApi = createAction(
  '@faresApp/tibFares/GOT_ERROR_FROM_TIB_FARES_API'
);

export const displayTibFares = createAction<boolean>(
  '@faresApp/tibFares/DISPLAY_TIB_FARES'
);

export const logoutTibFaresApp = createAction(
  '@faresApp/tibFares/LOGOUT_TIB_FARES_APP'
);

const tibFaresReducer = createReducer(INITIAL_STATE, {
  [getTibFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotTibFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    tibsSent: {
      value: action.payload.tib_enviada.valor,
      quantity: action.payload.tib_enviada.quantidade,
    },
    tibsReceived: {
      value: action.payload.tib_recebida.valor,
      quantity: action.payload.tib_recebida.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map((mes: IPeriodo) => {
      const data: ILastTwelveMonths = {
        date: mes.data,
        faresReceived: {
          value: mes.tib_recebida.valor,
          quantity: mes.tib_recebida.quantidade,
        },
        faresPassedOn: {
          value: mes.tib_enviada.valor,
          quantity: mes.tib_enviada.quantidade,
        },
      };
      return data;
    }),
  }),
  [gotErrorFromTibFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [displayTibFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutTibFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,

    dateSearch: {
      start: '',
      end: '',
    },
    tibsSent: {
      value: 0,
      quantity: 0,
    },
    tibsReceived: {
      value: 0,
      quantity: 0,
    },
    lastTwelveMonths: [],
  }),
});

export default tibFaresReducer;
